import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AssessmentOverviewAdapter } from 'components/Assessments/ServicePlanAssessment/sections/AssessmentOverview/adapter'
import { PatientOverviewAdapter } from 'components/Assessments/ServicePlanAssessment/sections/PatientOverview/adapter'
import { AuthorizationAdapter } from 'components/Assessments/ServicePlanAssessment/sections/Authorization/adapter'
import { ServicePlanAdapter } from 'components/Assessments/ServicePlanAssessment/sections/ServicePlan/adapter'
import { VisitSchedulingAdapter } from 'components/Assessments/ServicePlanAssessment/sections/VisitScheduling/adapter'
import { FinalStepsAdapter } from 'components/Assessments/ServicePlanAssessment/sections/FinalSteps/adapter'
import { ServicePlanFormData } from 'components/Assessments/ServicePlanAssessment/types/ServicePlanFormData'
import { BaseSubsectionAdapter } from './BaseSubsectionAdapter'
import { BaseAssessmentAdapter } from './BaseAssessmentAdapter'
import { AdapterOptions, SectionAdapter } from './types'
import { AssessmentType } from '../../Clinical/Assessments/constants'
import { mutateFlatAnswers } from '../helpers'

/**
 * Array of all Service Plan section adapter instances
 */
const SERVICE_PLAN_SECTION_ADAPTERS:
  | BaseSubsectionAdapter<ServicePlanFormData>[]
  | SectionAdapter<ServicePlanFormData>[] = [
  new AssessmentOverviewAdapter(),
  new PatientOverviewAdapter(),
  new AuthorizationAdapter(),
  new ServicePlanAdapter(),
  new VisitSchedulingAdapter(),
  new FinalStepsAdapter()
]

export class ServicePlanAssessmentAdapter extends BaseAssessmentAdapter<ServicePlanFormData> {
  readonly assessmentType = AssessmentType.SERVICE_PLAN

  protected flatAnswersToFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options?: AdapterOptions
  ): ServicePlanFormData {
    const formData: Partial<ServicePlanFormData> = {}

    for (const adapter of SERVICE_PLAN_SECTION_ADAPTERS) {
      const sectionData = adapter.extractFormData(flatAnswers, options)
      Object.assign(formData, sectionData)
    }

    return formData as ServicePlanFormData
  }

  protected formDataToFlatAnswers(
    formData: ServicePlanFormData,
    currentFlatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Record<string, QuestionnaireResponseItem> {
    // Use composable section adapters for clean, maintainable transformation
    const allMutations: Array<{ linkId: string; value: unknown }> = []

    // Build mutations from all section adapters dynamically
    for (const adapter of SERVICE_PLAN_SECTION_ADAPTERS) {
      if (adapter instanceof BaseSubsectionAdapter) {
        adapter.setFormData(formData)
        allMutations.push(...adapter.buildFlatAnswers())
      } else {
        allMutations.push(...adapter.buildFlatAnswers(formData))
      }
    }

    // Apply all mutations using existing helper
    mutateFlatAnswers(currentFlatAnswers, allMutations)

    return currentFlatAnswers
  }
}
